import React from 'react'
import PropTypes from 'prop-types'
import { Textfit } from 'react-textfit'

import './PlannedShotBox.css'
import withPolyglot from '../../../../../common/withPolyglot'
import moment from 'moment'

const STATUS_COLORS = {
  late: '#ff6b63',
  current: '#f2cb30',
  future: '#eee'
}

function getColorForStatus (status) {
  switch (status) {
    case 'late':
      return STATUS_COLORS.late
    case 'current':
      return STATUS_COLORS.current
    default:
      return STATUS_COLORS.future
  }
}
//
// function getRecommendationStatus (recommendation) {
//   const earliest = moment(recommendation.dateCriterion.earliest)
//   const latest = moment(recommendation.dateCriterion.latest)
//   const today = moment()
//   if (today.isBetween(earliest, latest)) {
//     return 'current'
//   } else if (today.isAfter(latest)) {
//     return 'late'
//   } else {
//     return 'future'
//   }
// }

function getNextShotTime (value, unit, translate) {
  switch (unit) {
    case 'year':
      return translate('numYears', true, 'timing', {smart_count: value})
    case 'month':
      return translate('numMonths', true, 'timing', {smart_count: value})
    case 'week':
      return translate('numWeeks', true, 'timing', {smart_count: value})
    case 'day':
      return translate('numDays', true, 'timing', {smart_count: value})
    default:
      return `${value} ${unit}`
  }
}

function isShotInFuture (patientBirth, val, unit) {
  const birth = moment(new Date(patientBirth))
  const shotDate = moment(birth).add(val, unit)
  const today = moment()
  if (today.isAfter(shotDate)) {
    return 'late'
  } else return 'future'
}

// TODO Put next distance
const PlannedShotBox = ({handleClick, shot, translate, patientBirthDate}) => {
  return <div className='uk-height-small shot-grid-cell tester'>
    <div
      className={`planned-shot uk-align-center`}
      style={{borderColor: getColorForStatus(isShotInFuture(patientBirthDate, shot.val, shot.unit))}}
      onClick={handleClick}>
      <div className='content'>
        <Textfit min={13} max={14}>
          {translate('doseNumber')}: {shot.sequenceNumber}
        </Textfit>
        <br className='hidden-on-small-screen' />
        <Textfit min={11} max={12}>
          {`${getNextShotTime(shot.val, shot.unit, translate)}`}
        </Textfit>
      </div>
    </div>
  </div>
}

PlannedShotBox.propTypes = {
  handleClick: PropTypes.func.isRequired,
  patientBirthDate: PropTypes.string.isRequired,
  shot: PropTypes.object.isRequired
}
export default withPolyglot(PlannedShotBox, 'plannedShotBox')
